
import { defineComponent, PropType } from 'vue'

import { Maybe, Run, RunConnection, RunStatus } from '~/types/types'

import { fromNow } from '~/utils/date'
import { runStatusIcon, runStatusIconColor } from '~/utils/ui'

export default defineComponent({
  name: 'LastRunInfo',
  props: {
    latestAnalysisRun: {
      type: Object as PropType<Maybe<Run>>,
      required: false
    },
    runs: {
      type: Object as PropType<Maybe<RunConnection>>,
      required: false
    }
  },
  computed: {
    currentlyAnalyzingRuns(): Maybe<number> | undefined {
      return this.runs?.totalCount
    },
    lastRun(): Run | null {
      return this.latestAnalysisRun || null
    },
    lastRunCommitOid(): string | undefined {
      return this.lastRun?.commitOid?.slice(0, 7)
    },
    lastRunFinishedAt(): string {
      const finishedAt = this.lastRun?.finishedAt

      if (!finishedAt) {
        return ''
      }

      return fromNow(finishedAt)
    },
    runPagePath(): string {
      return this.$generateRoute([
        'run',
        this.lastRun?.runId,
        this.lastRun?.config?.analyzers[0].name
      ])
    },
    statusIcon(): string {
      return runStatusIcon(this.lastRun?.status as RunStatus)
    },
    statusIconColor(): string {
      return runStatusIconColor(this.lastRun?.status as RunStatus)
    }
  }
})
